<template lang='pug'>
Input(:commit='doCommit' :theValue='theValue')
  input(class='form-control' type='text' :value='theValue' :size='size')
</template>

<script>
import Input from './Input'

export default {
  components: { Input },

  props: {
    theValue: {
      type: String,
      default: ''
    },
    commit: Function,
    size: {
      type: Number,
      default: 20
    }
  },

  methods: {
    async doCommit(value) {
      await this.commit(value)
    }
  }
}
</script>
